import React from 'react';
import Layout from '../../shared/components/Layout';
import Complete from '@/components/Complete';

const CancelRequestComplete: React.FC = () => {
  return (
    <React.Fragment>
      <Layout>
        <Complete id="page-facility_login" heading="キャンセル完了" content="キャンセルが完了しました。"isFacility={false}  />
      </Layout>
    </React.Fragment>
  )
}

export default CancelRequestComplete;